export interface ITableWithFilterModelGeneric<IT> {
    filters: IGridFilters;
    data: Array<IT>;
    tableDescription: ITableDescription;
}

export interface ITableWithFilterModelDataListGeneric<IT> {
    dataList: Array<IDataListItemModel<IT>>;
    filters: IGridFilters;
    data: Array<IT>;
    tableDescription: ITableDescription;
}

export interface IGridFilters {
    [key: string]: Record<string, string>[];
}

export interface IDataListItemModel<IT> {
    key: string;
    data: Array<IT>;
    ids: Array<number>;
}

export interface ITableDescription {
    count: number;
    totalCount: number;
    pageCount: number;
    idFieldName: string;
    isShowCheckRow: boolean;
    extendedFiltersView: boolean;
    columnsConfig: Array<ITableMappingDto>;
}

export interface ITableMappingDto {
    displayName: string;
    columnName: string;
    sortName: string;
    isHidden: boolean;
    hasFilter: boolean;
    hasCheckbox: boolean;
    hasTagFilter: boolean;
    hasDateRangeFilter: boolean;
    isUsedInCommonSearch: boolean;
    columnFilterType?: ColumnFilterTypeEnum;
}

export enum ColumnFilterTypeEnum {
    None= 0,
    General= 1,
    Tag= 2,
    DateTimeRange= 3,
    Text= 4
}

export class PagingInfo {
    pageSize: number;
    pageIndex: number;
    totalItems: number;
    get pageCount(): number {
        return Math.ceil(this.totalItems / this.pageSize);
    }
    get pageFirstNo(): number {
        return ( this.pageIndex - 1 ) * this.pageSize + 1;
    }
    get pageLastNo(): number {
        return this.pageFirstNo + this.pageSize - 1;
    }
    constructor(pageSize?: number, pageIndex?: number, totalItems?: number) {
        this.totalItems = totalItems || 0;
        this.pageSize = pageSize || GridConfig.defaultItemsPerPage;
        pageIndex = pageIndex || 0;
        this.pageIndex = (pageIndex > this.pageCount ? this.pageCount : pageIndex) || 1;
    }
}

export class GridConfig {
    static defaultItemsPerPage = 10;

    static pageSizes = [
        {
            value: 10,
            label: 10
        },
        {
            value: 25,
            label: 25
        },
        {
            value: 50,
            label: 50
        },
        {
            value: 100,
            label: 100
        }
    ];

    static get emptyGridRequest(): any {
        return {
            pageSize: 1,
            pageIndex: 1,
            textFilter: '',
            columnFilters: {},
            sortColumn: '',
        };
    }
}

export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export interface DateRangePickerOutput {
    dateRange: Array<string>;
    columnName: string;
    sortOrder?: string;
    sortOrderName?: string;
}
